// RITA-1599 — Texte der Hinweise im Vorlagen-Editor (gelber Kasten unter der Zuordnung und Rückfrage beim Speichern).
// Wortlaut mit Julia am 03.11.2026 abgestimmt (Jira RITA-1599, „Abgestimmter Wortlaut“). Die Hinweise warnen nur;
// gesperrt wird nichts, und getippte Platzhalter werden nicht umgewandelt (Entscheidung Julia 30.09.2026).
import { VORLAGEN_GESCHLECHTER } from './vorlagenZuordnung';

export const HINWEISE_TITEL = 'Bitte prüfen: Diese Stellen passen vielleicht nicht';
export const STELLE_ZEIGEN = 'Stelle zeigen';

export const VERTRAGSPARTNER_FEHLT_TEXT =
  'Der Vertrag enthält kein {{VERTRAGSPARTNER}}. Ist beim Berater ein abweichender Vertragsinhaber eingetragen, steht sonst die falsche Person im Vertrag.';
export const ANREDE_VOR_VERTRAGSPARTNER_TEXT =
  '{{ANREDE}} steht direkt vor {{VERTRAGSPARTNER}}. Im Vertrag stünde dann „Herr Herr Max Mustermann“. {{VERTRAGSPARTNER}} bringt die Anrede schon mit.';
export const ANREDE_VOR_VERTRAGSINHABER_TEXT =
  '{{ANREDE}} steht direkt vor {{VERTRAGSINHABER}}. Im Vertrag stünde dann „Herr Firma Muster Reisen GmbH“. {{VERTRAGSINHABER}} bringt „Herr“, „Frau“ oder „Firma“ schon mit.';
export const ANREDE_BEI_FIRMA_TEXT =
  'Diese Vorlage ist für eine Firma als Vertragspartner. {{ANREDE}} setzt aber „Herr“ oder „Frau“ des Beraters ein. Prüfe, ob das hier gewollt ist.';
export const PERSOENLICHE_ANREDE_BEI_FIRMA_TEXT =
  'Diese Vorlage ist für eine Firma als Vertragspartner. {{PERSOENLICHE_ANREDE}} setzt aber „Lieber Max“ oder „Liebe Anna“ des Beraters ein. Prüfe, ob das hier gewollt ist.';

/** `getippt` ist der Text genau so, wie er im Vertrag steht, etwa „{{VORNAME}}“. */
export const getippterPlatzhalterText = (getippt: string) =>
  `„${getippt}“ ist von Hand getippt und wird nicht ersetzt. Im Druck steht genau dieser Text. Lösche ihn und füge den Platzhalter über die Platzhalter-Leiste ein.`;

/** „2-mal“; ein einzelner Fund heißt „einmal“. */
const mal = (anzahl: number) => (anzahl === 1 ? 'einmal' : `${anzahl}-mal`);

/** Vorlage „Berater“ mit dem Wort „Beraterin“ im Text bzw. umgekehrt. */
export const falschesGeschlechtText = (fuer: 'male' | 'female', anzahl: number) => {
  const wort = fuer === 'male' ? VORLAGEN_GESCHLECHTER.female : VORLAGEN_GESCHLECHTER.male;
  return `Diese Vorlage ist für „${VORLAGEN_GESCHLECHTER[fuer]}“, im Text steht aber ${mal(anzahl)} „${wort}“.`;
};

// Feste Hinweisleiste im Titel (Entscheidung Julia 03.11.2026): sobald der gelbe Kasten aus dem Bild gescrollt ist,
// steht im festen Titelbereich eine orange Leiste mit der Anzahl; „Anzeigen“ holt den Kasten zurück ins Bild.
export const hinweisleisteText = (anzahl: number) =>
  anzahl === 1
    ? 'Bitte prüfen: 1 Stelle passt vielleicht nicht'
    : `Bitte prüfen: ${anzahl} Stellen passen vielleicht nicht`;
export const HINWEISE_ANZEIGEN = 'Anzeigen';

// Rückfrage beim Speichern
export const SPEICHERN_FRAGE_TITEL = 'Vorlage trotzdem speichern?';
export const speichernFrageText = (anzahl: number) =>
  anzahl === 1
    ? 'Das PRM hat 1 Stelle gefunden, die vielleicht nicht passt:'
    : `Das PRM hat ${anzahl} Stellen gefunden, die vielleicht nicht passen:`;
export const SPEICHERN_FRAGE_HINWEIS =
  'Zurück zur Vorlage: Nichts wird gespeichert. Trotzdem speichern: Die Vorlage gilt sofort für alle passenden Berater.';
export const ZURUECK_ZUR_VORLAGE = 'Zurück zur Vorlage';
export const TROTZDEM_SPEICHERN = 'Trotzdem speichern';
